import clsx from 'clsx';
import { useEffect, useRef } from 'react';

import { useIntersectionObserver } from '../IntersectionObserver';

import * as styles from './Mark.module.css';

export type MarkProps = {
  children?: string;
  className?: string;
  markerColor?: string;
  animated?: boolean; // Apply the marker when the element enters the viewport
};

export const Mark: React.FC<MarkProps> = ({ children, className, markerColor, animated = false }) => {
  const ref = useRef<HTMLElement>(null);
  const { entry, observe, unobserve } = useIntersectionObserver(ref, { threshold: 1 });

  useEffect(() => {
    if (!ref.current) {
      console.error('Ref is not attached to the element');
    }
  }, []);

  useEffect(() => {
    if (!ref.current) return;
    if (animated) observe();
    if (entry?.isIntersecting) unobserve();
  }, [entry?.isIntersecting]);

  return (
    <mark
      className={clsx(
        styles.mark,
        animated ? styles.animated : styles.normal,
        entry?.isIntersecting && styles.animate,
        className,
      )}
      style={{ '--marker-color': markerColor } as React.CSSProperties}
      ref={ref}
    >
      {children}
    </mark>
  );
};
